import logo from './logo.svg';
import './App.css';
import Home from './components';
import { LoginHome } from './Auth/Login';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormafusionSignup from './components/FormafusionSignup';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginHome />} />
        <Route path="/register" element={<FormafusionSignup />} />
      </Routes>
    </Router>
  );
}

export default App;
